import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

interface RedactorRouteProps {
  children: React.ReactNode;
}

export function RedactorRoute({ children }: RedactorRouteProps) {
  const { user, loading, isRedactor, isAdmin } = useAuth();

  // Les admins ont aussi accès aux fonctionnalités de rédaction
  const hasAccess = isRedactor || isAdmin;

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-brand-primary" />
      </div>
    );
  }

  if (!user || !user.emailVerified || !hasAccess) {
    console.log('Access denied:', {
      hasUser: !!user,
      emailVerified: user?.emailVerified,
      isRedactor,
      isAdmin,
      hasAccess
    });
    return <Navigate to="/" />;
  }

  return <>{children}</>;
}

export default RedactorRoute;
